import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ItemService } from '@services/item.service';
import { NotificationService } from '@services/notification.service';
import { QuestionService } from '@services/question.service';
import { WebErrorService } from '@services/webError.service';
// import { Editor } from 'ngx-editor';
import { Subscription } from 'rxjs';
import { GlobalToolbarConfig } from 'src/app/shared/addnewquestion';
import { CkeditorConfig, QuestionSubTypeIdEnum, QuestionTypeIdEnum } from 'src/app/shared/config/questions.config';
import * as Editor from '../../../../assets/ckeditor';
import Adapter from '../ckeditorAdapter';
@Component({
  selector: 'app-items-survey-short-answer',
  templateUrl: './items-survey-short-answer.component.html',
  styleUrls: ['./items-survey-short-answer.component.scss']
})
export class ItemsSurveyShortAnswerComponent implements OnInit {
  toolbar = GlobalToolbarConfig;
  isCkeditorLoading: boolean = true;
  private routerSubscription: Subscription;

  reuseProp = {
    questionuuId: 'questionuuId',
    questiondescription: 'questiondescription',
    description: 'description',
    correctPoints: 'correctPoints',
    maximumcharacterForFreetext: 'maximumcharacterForFreetext',
    itemId: 'itemId',
    penaltyPoints: 'penaltyPoints',
    minScoreIfAttempt: 'minScoreIfAttempt',
    scoringTypeExactMatch: 'scoringTypeExactMatch'
  };

  ckeditorConfig = CkeditorConfig;
  display = true;
  itemId: string;
  questionId: string;
  surveyShortAnswerForm: FormGroup;
  // questionEditor = new Editor();
  isListMode: boolean = false;
  isEditMode: boolean = false;
  @Output() postCreated = new EventEmitter();
  //-------- CKEditor5 Version---------
  @ViewChild("myEditor") myEditor: any;
  public Editor: any = Editor;
  errorMessage;
  QuestionSubTypeIdEnum = QuestionSubTypeIdEnum;
  QuestionTypeIdEnum = QuestionTypeIdEnum;  public uploadedFileNames = [];
  QuestionImages = []
  imageId: number = 1;
  constructor(private router: Router,
    private routerstate: ActivatedRoute,
    public questionService: QuestionService,
    private webErrorService: WebErrorService,
    private notificationService: NotificationService,
    public itemservice: ItemService,
    private translate: TranslateService,
  ) {
    this.routerSubscription = this.routerstate?.parent?.params?.subscribe((data) => {
      this.itemId = data.id;
    });

    this.questionId = sessionStorage.getItem(this.reuseProp.questionuuId);
    if (!this.questionId) {
      this.questionId = this.router.getCurrentNavigation()?.extras?.state?.questionId;
    }

    this.surveyShortAnswerForm = new FormGroup({
      ansRenderCount: new FormControl(0),
      questionOrder: new FormControl(0),
      questionSubTypeId: new FormControl(QuestionSubTypeIdEnum.SurveyShortAnswer),
      questionTypeId: new FormControl(QuestionTypeIdEnum.SurveyShortAnswer),
      questiondisplayoptions: new FormControl('Vertical'),
      active: new FormControl(true),
      autoScoring: new FormControl(false),
      allowCheckAnswer: new FormControl(false),
      shuffleOption: new FormControl(false),
      [this.reuseProp.scoringTypeExactMatch]: new FormControl('true'),
      [this.reuseProp.questiondescription]: new FormGroup({ description: new FormControl('', Validators.required), mediaURL: new FormControl([""]), file_name: new FormControl([""]) }),
      [this.reuseProp.itemId]: new FormControl(''),
      [this.reuseProp.correctPoints]: new FormControl(0),
      [this.reuseProp.maximumcharacterForFreetext]: new FormControl(0 , [Validators.required]),
      [this.reuseProp.penaltyPoints]: new FormControl(0),
      [this.reuseProp.minScoreIfAttempt]: new FormControl(0),
      questionImages: new FormControl('')
    });
  }

  onReady(editor) {
    // console.log(this.myEditor);
    // editor.ui
    //   .getEditableElement()
    //   .parentElement.insertBefore(
    //     editor.ui.view.toolbar.element,
    //     editor.ui.getEditableElement()
    //   );
    sessionStorage.setItem('ImageUploadFileSizeErr', 'false');
    sessionStorage.setItem('imageUploadErr', 'false');
    editor.plugins.get('FileRepository').createUploadAdapter = (loader: any) => {
      const adapter = new Adapter(loader, editor.config, this.itemservice);
      this.errorMessage = ''
      adapter.upload().catch((error) => {
        if (error === '') {
          if (sessionStorage.getItem('ImageUploadFileSizeErr') == 'true') {
            this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error');
          }

          if (sessionStorage.getItem('imageUploadErr') == 'true') {
            this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error1');
          }
          // this.itemservice.imageSizeErr.subscribe(x => {
          //   if(x == true) {
          //     this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error');
          //   }
          // });
          // this.itemservice.imageUploadErr.subscribe(x => {
          //   if(x == true) {
          //     this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error1');
          //     // this.itemservice.imageUploadErr.unsubscribe();
          //   }
          // });
        }
      });
      adapter.upload().then(res=>{
        this.uploadedFileNames.push(res.fileName)
        this.QuestionImages.push({"uniqueId": "#image" + this.imageId++ , "imageName": res.fileName, "base64": res.default})
      })
      return adapter;
    }
  }

  onClick(event) {
    if (this.errorMessage && event) this.errorMessage = false;
  }

  ngOnInit(): void {
    // this.questionEditor = new Editor();
    if (this.questionId) {
      this.isEditMode = true;
      const questionServiceGetSubscription: Subscription = this.questionService
        .getQuestion(this.itemId, this.questionId)
        .subscribe((resdata) => {
          this.surveyShortAnswerForm.patchValue(resdata.data);
          this.surveyShortAnswerForm.controls[this.reuseProp.scoringTypeExactMatch].setValue(JSON.stringify(resdata.data.scoringTypeExactMatch));
          questionServiceGetSubscription.unsubscribe()
        },
        (error) => {
          this.webErrorService.handleAPIErrors(error);
        });
    }
  }

  back() {
    this.postCreated.emit('false');
    this.display = false;
    // this.questionEditor.destroy();
  }

  saveQuestion() {
    this.surveyShortAnswerForm.controls[this.reuseProp.itemId].setValue(sessionStorage.getItem(this.reuseProp.itemId));
    this.surveyShortAnswerForm.controls[this.reuseProp.scoringTypeExactMatch].setValue(JSON.parse(this.surveyShortAnswerForm.controls[this.reuseProp.scoringTypeExactMatch].value));

    let question = this.surveyShortAnswerForm.value.questiondescription['description'];
    let question1 = question;//.replace(/(<([^>]+)>)/ig, '').replace(/^\s+/g, '').replace(/&nbsp;/g,'').trim();

    if (this.QuestionImages.length > 0) {
      this.QuestionImages.forEach(ele => {

        question1 = question1.replace(ele.base64, ele.uniqueId)

        let startIndex = ele.base64.lastIndexOf('base64,');
        ele.base64 = ele.base64.substring(startIndex +7)
      })
    }
    this.surveyShortAnswerForm.value.questiondescription['description'] = question1;
    this.surveyShortAnswerForm.value.questionImages = this.QuestionImages;

    this.surveyShortAnswerForm.value.questiondescription['file_name'] = this.uploadedFileNames;

    if (question1.length === 0) {
      this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.multipleResponse.errMsg3'), true, 'warn')
      return;  // Used to display alert message
    }

    if (this.isEditMode) {
      const questionServiceUpdateSubscription: Subscription = this.questionService.updateQuestion(this.surveyShortAnswerForm.value, this.itemId, this.questionId).subscribe(
        (resData) => {
          this.itemservice.editedGetItem(resData.data);
          this.notificationService.success(resData?.message);
          // this.itemservice.questionCountUpdate.next(true);
          // this.questionService.reloadList.next(true);
          this.isListMode = true;
          questionServiceUpdateSubscription.unsubscribe()
        },
        (error) => {
          this.webErrorService.handleAPIErrors(error, null, true, 'warn');
        });
    }
    else {
      const questionServicePostSubscription: Subscription = this.questionService.addQuestion(this.surveyShortAnswerForm.value, this.itemId).subscribe(
        (resData) => {
          this.isEditMode = true;
          this.notificationService.success(resData?.message);
          // this.itemservice.questionCountUpdate.next(true);
          // this.questionService.reloadList.next(true);
          this.isEditMode = true;
          this.isListMode = true;
          questionServicePostSubscription.unsubscribe()
        },
        (error) => {
          this.webErrorService.handleAPIErrors(error, null, true, 'warn');
        });
    }
  }

  onCkeditorReady() {
    this.isCkeditorLoading = false;
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}

